import { render, staticRenderFns } from "./AiLink.vue?vue&type=template&id=1272f820"
import script from "./AiLink.vue?vue&type=script&lang=js"
export * from "./AiLink.vue?vue&type=script&lang=js"
import style0 from "./AiLink.vue?vue&type=style&index=0&id=1272f820&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports